module.exports = __webpack_public_path__ + "img/btn@2x.fbf4bdb1.png";